<div
  class="min-h-screen flex flex-col items-center justify-center p-6 sm:p-12 lg:p-24 animate-in fade-in slide-in-from-right-4 duration-500">
  <div class="max-w-sm w-full">
    <!-- Icône de succès -->
    <div class="flex justify-center mb-6">
      <div class="w-32 h-32 bg-[#00A878]/10 rounded-full flex items-center justify-center">
        <div class="w-20 h-20 bg-[#00A878] rounded-full flex items-center justify-center shadow-lg shadow-[#00A878]/20">
          <ng-icon name="lucideCheckCircle2" size="48" color="white"/>
        </div>
      </div>
    </div>

    <!-- Titre -->
    <h1 class="text-2xl text-center text-[#1A2E47] font-bold mb-4">
      Inscription réussie!
    </h1>

    <!-- Message -->
    <p class="text-center text-gray-600 mb-8 px-4 leading-relaxed">
      Merci de vous être inscrit à notre application de gestion immobilière.
      Veuillez vérifier votre adresse e-mail pour confirmer votre compte.
    </p>


    <div class="p-4 mb-6 border-0 bg-[#1A2E47]/5 shadow-sm rounded-lg">
      <div class="flex items-start gap-3">
        <div class="w-10 h-10 bg-white rounded-lg flex items-center justify-center flex-shrink-0 shadow-sm">
          <ng-icon name="lucideMail" size="20" color="#1A2E47"/>
        </div>
        <div class="flex-1 min-w-0 pt-0.5">
          <p class="text-sm text-gray-600 mb-0.5">
            Un e-mail de confirmation a été envoyé à
          </p>
          <p class="text-sm text-[#1A2E47] font-semibold break-all">{{ userService.getCurrentUserSync()?.email }}</p>
        </div>
      </div>
    </div>

    <!-- Note spam -->
    <p class="text-xs text-center text-gray-500 mb-8 px-4">
      N'oubliez pas de vérifier votre dossier spam si vous ne trouvez pas l'e-mail dans
      votre boîte de réception.
    </p>

    <button
      z-button
      type="button"
      class="w-full bg-[#00A878] hover:bg-[#008f66] h-12 mb-4 font-medium shadow-md transition-all active:scale-[0.98]"
      (click)="router.navigate(['/setup/profile'])"
    >
      Continuer
    </button>


    <!-- Renvoyer l'email -->
    <div class="text-center">
      <p class="text-sm text-gray-600 mb-2">
        Vous n'avez pas reçu l'e-mail?
      </p>
      <button z-button type="button"
              class="border-[#1A2E47]/20 text-[#1A2E47] hover:bg-[#1A2E47]/5 hover:text-[#1A2E47] bg-[#1A2E47]/5"
              (click)="router.navigate(['/setup/profile'])">
        Renvoyer l'e-mail
      </button>
    </div>


    <!-- Logo -->
    <div class="flex items-center justify-center gap-2 mt-12 opacity-80">
      <img ngSrc="logo.svg" height="24" width="24" alt="BAILIA" class="w-6 h-6"/>
      <span class="text-[#1A2E47] font-bold tracking-tight">BAILIA</span>
    </div>
  </div>
</div>
